export default "__VITE_ASSET__BFkZr_Hr__"